import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function AllButton(props) {
  return (
    <div className="flex gap-[6px] justify-center items-center cursor-pointer group hover:text-[#FF4713] transition-colors">
      <h1 className="text-slateGray text-lead font-normal group-hover:text-[#FF4713] transition-colors">
        {props.lang === "th" ? "ทั้งหมด" : "See more"}
      </h1>
      <div className="flex -space-x-1 text-slateGray group-hover:text-[#FF4713] transition-colors">
        <FontAwesomeIcon icon={faChevronRight} className="text-small" />
        <FontAwesomeIcon icon={faChevronRight} className="text-small" />
      </div>
    </div>
  );
}
